var _path, _g, _g2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodeoU(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00502 15.5798C6.20045 15.1254 4.71059 14.0899 3.53542 12.4733C2.36024 10.8568 1.77292 9.06206 1.77344 7.08924V2.33766L8.00502 0.421875L14.2366 2.33766V7.08924C14.2366 9.06258 13.6493 10.8575 12.4746 12.4741C11.3 14.0907 9.8101 15.1259 8.00502 15.5798Z",
    fill: "#FF8A00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18093_36818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4818 3.99414V4.22364C11.237 4.25424 11.0496 4.31927 10.9195 4.41872C10.7971 4.51052 10.7168 4.6597 10.6785 4.86625C10.6403 5.0728 10.6211 5.36351 10.6211 5.73836V8.77927C10.6211 9.27652 10.5867 9.7317 10.5179 10.1448C10.449 10.5579 10.3266 10.9136 10.1507 11.212C9.95176 11.5409 9.66106 11.8011 9.27856 11.9923C8.89605 12.1836 8.41027 12.2792 7.82122 12.2792C7.46931 12.2792 7.10976 12.2371 6.74255 12.153C6.37535 12.0765 6.0464 11.9273 5.75569 11.7054C5.51089 11.4989 5.32346 11.2655 5.19341 11.0054C5.06336 10.7453 4.97539 10.4393 4.92949 10.0874C4.88358 9.72788 4.86063 9.3033 4.86063 8.81369V5.2105C4.86063 4.92745 4.83768 4.7209 4.79178 4.59085C4.75353 4.45315 4.67321 4.36134 4.55081 4.31544C4.4284 4.26189 4.2448 4.23129 4 4.22364V3.99414C4.19125 4.00179 4.44753 4.00944 4.76883 4.01709C5.09779 4.02474 5.43822 4.02857 5.79012 4.02857C6.14202 4.02857 6.47863 4.02474 6.79993 4.01709C7.12888 4.00944 7.40046 4.00179 7.61466 3.99414V4.22364C7.35456 4.23129 7.15566 4.26189 7.01796 4.31544C6.88791 4.36134 6.79993 4.45315 6.75403 4.59085C6.70813 4.7209 6.68518 4.92745 6.68518 5.2105V9.53663C6.68518 9.91913 6.70813 10.2596 6.75403 10.5579C6.80758 10.8486 6.89173 11.0934 7.00648 11.2923C7.12888 11.4836 7.29336 11.6289 7.49991 11.7284C7.70647 11.8278 7.96274 11.8776 8.26875 11.8776C8.80425 11.8776 9.22118 11.7513 9.51953 11.4989C9.82554 11.2464 10.0397 10.8983 10.1621 10.4546C10.2922 10.0033 10.3572 9.4869 10.3572 8.90549V5.87606C10.3572 5.45531 10.3304 5.134 10.2769 4.91215C10.2233 4.68265 10.1162 4.51817 9.95559 4.41872C9.80259 4.31927 9.56544 4.25424 9.24413 4.22364V3.99414C9.38948 4.00179 9.58074 4.00944 9.81789 4.01709C10.055 4.02474 10.2769 4.02857 10.4834 4.02857C10.667 4.02857 10.8468 4.02474 11.0228 4.01709C11.2064 4.00944 11.3594 4.00179 11.4818 3.99414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75579,
    cy: 4.7597,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75579,
    cy: 5.62689,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75579,
    cy: 6.49212,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75579,
    cy: 7.35736,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75579,
    cy: 8.22259,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75579,
    cy: 9.08782,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.81829,
    cy: 9.95501,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.00579,
    cy: 10.8202,
    r: 0.185482,
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.49798,
    cy: 11.5624,
    r: 0.185482,
    fill: "#FF8A00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18093_36818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51822 3.99414V4.22364C4.76302 4.25424 4.95045 4.31927 5.0805 4.41872C5.2029 4.51052 5.28323 4.6597 5.32148 4.86625C5.35973 5.0728 5.37885 5.36351 5.37885 5.73836V8.77927C5.37885 9.27652 5.41328 9.7317 5.48213 10.1448C5.55098 10.5579 5.67338 10.9136 5.84933 11.212C6.04824 11.5409 6.33894 11.8011 6.72144 11.9923C7.10395 12.1836 7.58973 12.2792 8.17878 12.2792C8.53069 12.2792 8.89024 12.2371 9.25745 12.153C9.62465 12.0765 9.9536 11.9273 10.2443 11.7054C10.4891 11.4989 10.6765 11.2655 10.8066 11.0054C10.9366 10.7453 11.0246 10.4393 11.0705 10.0874C11.1164 9.72788 11.1394 9.3033 11.1394 8.81369V5.2105C11.1394 4.92745 11.1623 4.7209 11.2082 4.59085C11.2465 4.45315 11.3268 4.36134 11.4492 4.31544C11.5716 4.26189 11.7552 4.23129 12 4.22364V3.99414C11.8087 4.00179 11.5525 4.00944 11.2312 4.01709C10.9022 4.02474 10.5618 4.02857 10.2099 4.02857C9.85798 4.02857 9.52137 4.02474 9.20007 4.01709C8.87112 4.00944 8.59954 4.00179 8.38534 3.99414V4.22364C8.64544 4.23129 8.84434 4.26189 8.98204 4.31544C9.11209 4.36134 9.20007 4.45315 9.24597 4.59085C9.29187 4.7209 9.31482 4.92745 9.31482 5.2105V9.53663C9.31482 9.91913 9.29187 10.2596 9.24597 10.5579C9.19242 10.8486 9.10827 11.0934 8.99352 11.2923C8.87112 11.4836 8.70664 11.6289 8.50009 11.7284C8.29353 11.8278 8.03726 11.8776 7.73125 11.8776C7.19575 11.8776 6.77882 11.7513 6.48047 11.4989C6.17446 11.2464 5.96026 10.8983 5.83786 10.4546C5.70781 10.0033 5.64278 9.4869 5.64278 8.90549V5.87606C5.64278 5.45531 5.66956 5.134 5.72311 4.91215C5.77666 4.68265 5.88376 4.51817 6.04441 4.41872C6.19741 4.31927 6.43456 4.25424 6.75587 4.22364V3.99414C6.61052 4.00179 6.41926 4.00944 6.18211 4.01709C5.94496 4.02474 5.72311 4.02857 5.51655 4.02857C5.33295 4.02857 5.15318 4.02474 4.97722 4.01709C4.79362 4.00944 4.64062 4.00179 4.51822 3.99414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.4297 4.57422)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.4297 5.44141)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.4297 6.30664)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.4297 7.17188)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.4297 8.03711)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.4297 8.90234)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.3672 9.76953)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 10.1797 10.6348)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.185482,
    cy: 0.185482,
    r: 0.185482,
    transform: "matrix(-1 0 0 1 9.6875 11.377)",
    fill: "#FF8A00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26511 5.95211L8.28993 5.90053L8.26511 5.95211L7.99684 5.82301L7.72857 5.95211L7.70375 5.90053L7.72857 5.95211C7.67187 5.9794 7.60729 5.93369 7.61417 5.87115L7.64861 5.55778L7.44501 5.32491C7.40474 5.27885 7.42886 5.20647 7.48871 5.19378L7.7806 5.13185L7.92621 4.86021C7.95643 4.80384 8.03725 4.80384 8.06746 4.86021L8.21308 5.13185L8.50497 5.19378C8.56482 5.20647 8.58893 5.27885 8.54866 5.32491L8.34506 5.55778L8.37951 5.87115C8.38638 5.93369 8.3218 5.9794 8.26511 5.95211Z",
    fill: "black",
    stroke: "#FF8A00",
    strokeWidth: 0.114477
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18093_36818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.0081,
    height: 8.68421,
    fill: "white",
    transform: "translate(3.99219 3.91602)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18093_36818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.0081,
    height: 8.68421,
    fill: "white",
    transform: "matrix(-1 0 0 1 12.0078 3.91602)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodeoU);
export default __webpack_public_path__ + "static/media/rodeo_u.699d869acdaff9fd3391f2ce3697107c.svg";
export { ForwardRef as ReactComponent };